import EventDrawer from "@/components/event-drawer/index";
import EventDetails from "@/components/event-details/index";
import ContentBlock from "@/components/content-block/index";
import EVENTS from "@/data/puppy-weekend/events.yaml";
import dynamicLocalization from "@/mixins/dynamic-localization";
import SimplePage from "@/components/simple-page";

export default {
  components: {
    EventDrawer,
    EventDetails,
    ContentBlock,
    SimplePage,
  },
  mixins: [dynamicLocalization],
  props: {
    eventKeyOrIndex: String,
    required: false,
    default: null,
  },
  data() {
    return {
      events: EVENTS,
      heroImage: "/images/puppy-weekend-2025/banner.png",
    };
  },
  computed: {
    eventKeys() {
      return this.events.reduce((keys, event) => keys.concat(event.keys), []);
    },
    eventIndexInt() {
      if (!this.eventKeyOrIndex) {
        return 0;
      }

      const indexFromKeys = this.eventKeys.indexOf(this.eventKeyOrIndex);

      if (indexFromKeys >= 0) {
        return indexFromKeys;
      }

      return parseInt(this.eventKeyOrIndex);
    },
    event() {
      return this.events[this.eventIndexInt];
    },
    nextEvent() {
      if (this.eventIndexInt >= this.events.length - 1) {
        return;
      }

      return this.events[this.eventIndexInt + 1];
    },
    prevEvent() {
      if (this.eventIndexInt === 0) {
        return;
      }

      return this.events[this.eventIndexInt - 1];
    },
  },
  methods: {
    onSelectEvent(event) {
      // Use user-friendly urls
      // if not available, fall back to index
      const eventKey =
        event.keys && event.keys.length > 0
          ? event.keys[0]
          : this.events.indexOf(event);

      this.$router.push({
        name: "puppy-weekend.program",
        params: {
          eventKeyOrIndex: String(eventKey),
        },
      });
    },
  },
};
